import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { selectAuth } from '../features/authSlice';
import { RootState } from "../store";
import { API_END_POINTS } from './apiEndpoints';
import { baseUrl } from './baseUrl';
import { DynamicBaseQueryHeader } from './DynamicBaseQueryHeader';

// const rawBaseQuery = fetchBaseQuery({
//     baseUrl: baseUrl.MAIN_BASE_URL,
// })

// type ExtraOptions = {
//     headers?: Record<string, string>;
//     // Define other optional properties here if needed
// };
// const dynamicBaseQuery: BaseQueryFn<
//     string | FetchArgs,
//     unknown,
//     FetchBaseQueryError,
//     ExtraOptions
// > = async (args, api, extraOptions) => {
//     const orgBaseUrl = selectAuth(api.getState() as RootState).baseURL;
//     // gracefully handle scenarios where data to generate the URL is missing
//     if (!orgBaseUrl) {
//         return {
//             error: {
//                 status: 400,
//                 statusText: 'Bad Request',
//                 data: 'dynamic route not found',
//             },
//         }
//     }
//     const urlEnd = typeof args === 'string' ? args : args.url
//     const adjustedUrl = `${orgBaseUrl}/api/SystemSetting${urlEnd}`
//     const adjustedArgs = typeof args === 'string' ? { url: adjustedUrl } : { ...args, url: adjustedUrl };
//     // Get the token from localStorage
//     const token = localStorage.getItem("user")
//         ? JSON.parse(localStorage.getItem("user")!).token
//         : null;
//     // Set headers if token is available
//     const headers = token ? { Authorization: `Bearer ${token}` } : {};
//     // Merge headers with existing headers
//     const mergedHeaders = { ...headers, ...extraOptions?.headers };
//     // provide the amended url and other params to the raw base query
//     return rawBaseQuery({ ...adjustedArgs, headers: mergedHeaders }, api, extraOptions)

// }

export const SystemSettingsApi = createApi({
    reducerPath: 'SystemSettingsApi',
    // baseQuery: dynamicBaseQuery,
    baseQuery: DynamicBaseQueryHeader("SystemSetting"),
    endpoints: (builder) => ({
        getEmailSettingBySenderType: builder.query({
            query: (EmailSenderTypeId) => {
                return {
                    url: `${API_END_POINTS.getEmailSettingBySenderType}?EmailSenderTypeId=${EmailSenderTypeId}`,
                    method: "GET",
                }
            },
        }),
        addUpdateEmailSetting: builder.mutation({
            query: (body) => {
                return {
                    url: API_END_POINTS.addUpdateEmailSetting,
                    method: "POST",
                    body,
                }
            },
        }),
        getOrgServiceLookup: builder.query({
            query: () => {
                return {
                    url: `${API_END_POINTS.getOrgServiceLookup}`,
                    method: "GET",
                }
            },
        }),
        getKeysandValuesOfServiceByServiceId: builder.query({
            query: (params) => {
                return {
                    url: `${API_END_POINTS.getKeysandValuesOfServiceByServiceId}`,
                    method: "GET",
                    params
                }
            },
        }),
        addKeyAndValue: builder.mutation({
            query: (body) => {
                return {
                    url: API_END_POINTS.addKeyAndValue,
                    method: "POST",
                    body,
                }
            },
        }),
        updateKeyAndValue: builder.mutation({
            query: (body) => {
                return {
                    url: API_END_POINTS.updateKeyAndValue,
                    method: "POST",
                    body,
                }
            },
        }),
    }),
})


export const {
    useAddUpdateEmailSettingMutation,
    useGetEmailSettingBySenderTypeQuery,
    useGetOrgServiceLookupQuery,
    useGetKeysandValuesOfServiceByServiceIdQuery,
    useAddKeyAndValueMutation,
    useUpdateKeyAndValueMutation
} = SystemSettingsApi